module.exports = __webpack_public_path__ + "0d57dc55f8757dd2a6d3404be64f4aad.pdf";